module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-row-pc"
  }, [_c('div', {
    staticClass: "item-header"
  }, [_c('div', {
    staticClass: "item-title"
  }, [(_vm.item.un_pin === 2) ? _c('div', {
    staticClass: "unpin"
  }, [_c('i', {
    staticClass: "fa fa-star"
  })]) : _vm._e(), (_vm.item.private_community.icon && _vm.item.private_community.icon !== null && _vm.item.private_community.icon.length) ? _c('img', {
    attrs: {
      "src": _vm.item.private_community.icon
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/faces/avt-default.png")
    }
  }), (_vm.item.position === 2) ? _c('span', [_vm._v(_vm._s(_vm.item.private_community.name) + " (TRỢ LÝ)")]) : _c('span', [_vm._v(_vm._s(_vm.item.private_community.name))])]), (_vm.$isMobile()) ? _c('div', {
    staticClass: "item-function",
    class: [(_vm.keyActive === 'itemPC_' + _vm.item.pc_id && _vm.isPopover) ? 'open-popover' : ''],
    on: {
      "click": function($event) {
        return _vm.clickPopover('itemPC_' + _vm.item.pc_id)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons text-gray",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("more_horiz")]), _c('div', {
    ref: "popoverPC",
    staticClass: "box-popover"
  }, [(_vm.item.un_pin === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim cộng đồng")]) : _vm._e(), (_vm.item.un_pin === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 2)
      }
    }
  }, [_vm._v("Ghim cộng đồng")]) : _vm._e()])]) : _c('div', {
    staticClass: "item-function and-hover"
  }, [_c('i', {
    staticClass: "material-icons text-gray",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("more_horiz")]), _c('div', {
    ref: "popoverPC",
    staticClass: "box-popover"
  }, [(_vm.item.un_pin === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim cộng đồng")]) : _vm._e(), (_vm.item.un_pin === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 2)
      }
    }
  }, [_vm._v("Ghim cộng đồng")]) : _vm._e()])])]), (_vm.lstClasses && _vm.lstClasses.length > 0) ? _c('div', {
    staticClass: "item-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-custom-padding"
  }, _vm._l((_vm.lstClasses), function(classes, index) {
    return _c('div', {
      staticClass: "item-classes-pc col-md-2 col-sm-2 col-xs-6"
    }, [_c('ItemClasses', {
      key: _vm.increment,
      attrs: {
        "item": classes,
        "keyPopoverClass": _vm.keyPopoverClass,
        "keyActiveClass": _vm.keyActiveClass,
        "keySmart": _vm.keySmart
      },
      on: {
        "onFlagDeleted": _vm.onFlagDeleted,
        "onDeleted": _vm.onDeleted,
        "onUnpinClass": _vm.unpinClass,
        "copyLinkJoin": _vm.doCopy,
        "resetPopoverClass": _vm.resetPopoverClass
      }
    })], 1)
  }), 0)])]) : _vm._e(), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee2ce1c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassesMe/item.vue
// module id = 1541
// module chunks = 0